import React from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';

import ClearAllBtn from '../ClearAllBtn/ClearAllBtn';
import CollectionFilterList from '../CollectionFilterList/CollectionFilterList';

import useWindowWidth from '../../hooks/useWindowWidth';

import { StyledWrapper, StyledCategoriesDiv, StyledFiltersDiv, StyledH5 } from './CollectionFiltersStyles';
import { StyledLi } from '../CollectionFilterItem/CollectionFilterItemStyles';
import CollectionSubMenu from '../CollectionSubMenu/CollectionSubMenu';

var _ref = React.createElement(
  StyledH5,
  null,
  'Categories'
);

var CollectionFilters = function CollectionFilters(props) {
  var windowWidth = useWindowWidth();

  var getFilterTags = function getFilterTags(allCollectionTags, data) {
    return data.filter(function (tag) {
      return allCollectionTags.includes(tag.title);
    });
  };

  var dormifyXYou = props.dormifyXYouPage;
  var printPage = dormifyXYou || window.location.pathname.includes('collections/prints');
  return React.createElement(
    StyledWrapper,
    { showMobileFilter: props.showMobileFilter },
    React.createElement(
      Sticky,
      {
        top: 100,
        bottomBoundary: '.Collection',
        enabled: windowWidth >= 769
      },
      props.subMenu && React.createElement(
        StyledCategoriesDiv,
        null,
        _ref,
        React.createElement(
          'ul',
          null,
          props.subMenu.map(function (column, ind) {
            // hide current url link
            if (column.links) {
              return column.links.map(function (link, i) {
                return link.url !== window.location.pathname &&
                // Hide Column Header
                i !== 0 && React.createElement(
                  StyledLi,
                  {
                    key: link.title,
                    active: window.location.pathname === link.url
                  },
                  React.createElement(
                    'a',
                    { href: link.url },
                    link.title
                  )
                );
              });
            } else {
              return column.url !== window.location.pathname && ind !== 0 && React.createElement(
                StyledLi,
                {
                  key: column.title,
                  active: window.location.pathname === column.url
                },
                React.createElement(
                  'a',
                  { href: column.url },
                  column.title
                )
              );
            }
          })
        )
      ),
      React.createElement(
        StyledFiltersDiv,
        null,
        React.createElement(
          StyledH5,
          null,
          'Filters',
          props.activeFilterCount > 0 && React.createElement(
            'span',
            null,
            ' (',
            props.activeFilterCount,
            ')'
          )
        ),
        props.showMobileFilter && props.activeFilterCount > 0 && React.createElement(ClearAllBtn, { onClick: props.handleFilterClearAll }),
        !dormifyXYou && props.collectionFilters && props.collectionFilters.map(function (filter) {
          var filterTags = getFilterTags(props.allCollectionTags, filter.data);
          if (filterTags.length > 1) {
            return React.createElement(CollectionFilterList, {
              key: filter.title,
              title: filter.title,
              filterTags: filterTags,
              handleFilterClick: props.handleFilterClick,
              activeFilters: props.activeFilters,
              useSwatch: filter.title === 'Color Type',
              useListItem: filter.title === 'Sub Category' || filter.title === 'Art Type'
            });
          }
        }),
        printPage && props.artistFilters && props.artistFilters.map(function (filter) {
          var filterTags = getFilterTags(filter.data.map(function (tag) {
            return tag.title;
          }), filter.data);
          return React.createElement(CollectionFilterList, {
            key: filter.title,
            title: filter.title,
            filterTags: filterTags,
            handleFilterClick: props.handleFilterClick,
            activeFilters: props.activeFilters,
            useSwatch: false,
            useListItem: true,
            useLink: dormifyXYou
          });
        })
      )
    )
  );
};

CollectionFilters.propTypes = {
  activeFilters: PropTypes.object.isRequired,
  activeFilterCount: PropTypes.number.isRequired,
  filteredProducts: PropTypes.array.isRequired,
  artistFilters: PropTypes.array,
  collectionFilters: PropTypes.array,
  allCollectionTags: PropTypes.array,
  showMobileFilter: PropTypes.bool.isRequired,
  toggleMobileFilterPopup: PropTypes.func.isRequired,
  handleFilterClick: PropTypes.func.isRequired,
  handleFilterClearAll: PropTypes.func.isRequired,
  subMenu: PropTypes.array,
  dormifyXYouPage: PropTypes.bool
};

export default CollectionFilters;